import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useContext } from "react";
import { AppContext } from "../../scripts/context/App";

import PageTitle from "../PageTitle";
import ChangeAvatar from "./ChangeAvatar";
import ToggleTwoFactorAuthentication from "./ToggleTwoFactorAuthentication";
import UpdateInformation from "./UpdateInformation";

export default function ProfilePage() {
  const { user } = useContext(AppContext);

  return (
    <>
      <PageTitle
        title="Profile"
        description="Manage your profile and settings"
      />
      <Box p={3}>
        <Box sx={{ display: 'flex' }}>
          <ChangeAvatar />
          <Box sx={{ ml: 2 }}>
            <Typography variant="h6" color="textPrimary">
              {user.full_name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {user.email}
            </Typography>
          </Box>
        </Box>
        
        <UpdateInformation />
        <ToggleTwoFactorAuthentication />
      </Box>
    </>
  );
}